import { Component, Inject, OnInit } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EnterValueDialogComponent } from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-dialog.component';
import { EnterValueInput } from '../../../../projects/kiene-core/src/lib/components/dialogs/enter-value-dialog/enter-value-response';
import { PdfViewerDesktopService } from '../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneUtils } from '../../../../projects/kiene-core/src/lib/utils/KieneUtils';
import { ClientService } from '../../administration/client/client.service';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import {
    FunctionTableColumn,
    KieneBooleanTableColumn,
    NumberTableColumn,
    TextTableColumn,
} from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { FilterItem } from '../../../../projects/kiene-core/src/lib/services/backend-api/classes/filter-item';
import { FilterItemType } from '../../../../projects/kiene-core/src/lib/services/backend-api/classes/filter-item';
import { isEinkaufVerbrauchArticle, Material } from '../../warehouse/material/material';
import { TextProposalService } from '../text-autocomplete/text-proposal.service';
import { AddBehandlungsartikelDialogComponent } from './add-behandlungsartikel-dialog/add-behandlungsartikel-dialog.component';

@Component({
    selector: 'kiene-behandlungs-artikel',
    templateUrl: './behandlungs-artikel.component.html',
    styleUrls: ['./behandlungs-artikel.component.scss'],
})
export class BehandlungsArtikelComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        public dialog: MatDialog,
        private pdfService: PdfViewerDesktopService,
        private clientService: ClientService,
        private router: Router,
        private api: KieneTableService,
        private messageService: MessageService,
        private localStorageService: LocalStorageService,
        private service: TextProposalService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Labor- und Diagnostikartikel';
        this.tableDescriptor.uniqueIdentifier = 'Laborartikel';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'behandlungsartikel/';
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetails = true;
        this.tableDescriptor.showDetailsExpandable = false;
        this.tableDescriptor.showDetailsVoid = this.openEditBehandlungsartikelDialog.bind(this);
        this.tableDescriptor.nameOfIdField = 'artikel_id';
        this.tableDescriptor.permissionCreate = 1023;

        this.tableDescriptor.columns = this.getTableColumns();
        this.tableDescriptor.options = this.getTableOptions();

        this.tableDescriptor.initialSortColumn = 'bezeichnung';
        this.tableDescriptor.initialSortDirection = 'asc';

        this.tableDescriptor.permissionView = 1021;
        this.tableDescriptor.skipOptionsTablePadding = true;
        this.tableDescriptor.addVoid = this.openAddBehandlungsartikelDialog.bind(this);
        
        // Filter für Artikeltyp hinzufügen
        this.tableDescriptor.filterItems.push(
            new FilterItem('Laborartikel', 1, FilterItemType.CHECKBOX, 'laborartikel', false),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('Diagnostikartikel', 0, FilterItemType.CHECKBOX, 'laborartikel', false),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('aktive Artikel', 0, FilterItemType.CHECKBOX, 'gesperrt', false),
        );
        this.tableDescriptor.filterItems.push(
            new FilterItem('gesperrte Artikel', 1, FilterItemType.CHECKBOX, 'gesperrt', false),
        );
    }

    getTableColumns() {
        const columns = [];
        columns.push(
            new TextTableColumn('artikel_id', 'Nr.', {
                maxWidth: '8ch',
                maxLength: 8,
            }),
        );
        columns.push(
            new TextTableColumn('artikeltyp', 'Typ', {
                maxWidth: '16ch',
                maxLength: 18,
            }),
        );
        columns.push(
            new TextTableColumn('bezeichnung', 'Name', {
                maxWidth: '32ch',
                maxLength: 36,
            }),
        );
        columns.push(
            new TextTableColumn('bezeichnung_befund', 'Name auf Befund', {
                maxWidth: '28ch',
                maxLength: 32,
            }),
        );
        columns.push(
            new TextTableColumn('kommentar', 'Kommentar', {
                maxWidth: '28ch',
                maxLength: 40,
            }),
        );
        columns.push(
            new TextTableColumn('lieferant', 'Lieferant', {
                maxWidth: '24ch',
                maxLength: 28,
            }),
        );
        columns.push(
            new TextTableColumn('artikelnr_lieferant', 'Artikelnr. extern', {
                maxWidth: '16ch',
                maxLength: 20,
            }),
        );
        columns.push(
            new TextTableColumn('ean', 'EAN', {
                maxWidth: '16ch',
                maxLength: 20,
            }),
        );
        columns.push(
            new FunctionTableColumn('verbrauch_umsatz', 'Verbrauch/Umsatz', this.formatVerbrauchUmsatz),
        );
        if (this.localStorageService.hasPermission(3211)) {
            columns.push(new TextTableColumn('buchungskonto', 'Buchungskonto'));
            columns.push(new TextTableColumn('buchungsgegenkonto', 'Gegenkonto'));
        }
        if (this.localStorageService.hasPermission(1025)) {
            columns.push(new NumberTableColumn('einzelpreis', 'Einkaufspreis', '1.2-2', '€'));
        }
        columns.push(new NumberTableColumn('verkaufspreis', 'Verkaufspreis', '1.2-2', '€'));
        if (this.localStorageService.hasPermission(1025)) {
            columns.push(new NumberTableColumn('ertrag', 'Ertrag', '1.0-0', '%'));
        }
        columns.push(new KieneBooleanTableColumn('gesperrt', 'Laborartikel gesperrt'));
        return columns;
    }

    private formatVerbrauchUmsatz = (m: Material): string => {
        const labor = Number(m?.laborartikel) > 0;
        return isEinkaufVerbrauchArticle(m, labor) ? 'Verbrauch' : 'Umsatz';
    };

    getTableOptions() {
        const options = [];
        options.push(new TableOption(this.openEditBehandlungsartikelDialog.bind(this), 'bearbeiten', 'edit', 1023));
        options.push(
            new TableOption(this.laborartikelSperren.bind(this), 'Laborartikel sperren/entsperren', 'lock', 1025),
        );
        options.push(
            new TableOption(this.deleteBehandlungsartikel.bind(this), 'Artikel löschen', 'delete', 1023),
        );
        return options;
    }

    private laborartikelSperren(article: Material) {
        const istGesperrt = KieneUtils.isApiOne(article.gesperrt);
        const action1 = istGesperrt ? 'entsperren' : 'sperren';
        const action2 = istGesperrt ? 'entsperrt' : 'gesperrt';
        const enterValueInput = new EnterValueInput();
        enterValueInput.title = 'Laborartikel ' + action1;
        enterValueInput.text = 'Soll der Artikel ' + article.bezeichnung + ' ' + action2 + ' werden?';
        enterValueInput.okButton = action1;

        const dialogRef = this.dialog.open(EnterValueDialogComponent, { width: '700px', data: enterValueInput });

        dialogRef.afterClosed().subscribe(result => {
            if (result.result) {
                article.gesperrt = istGesperrt ? 0 : 1;
                this.api.post(this.apiBaseUrl + 'behandlungsartikel/update.php', article).subscribe({
                    next: response => {
                        const updatedArticle: Material = response;
                        this.messageService.infoMessage(
                            'Laborartikel erfolgreich ' + (KieneUtils.isApiOne(updatedArticle.gesperrt) ? 'gesperrt' : 'entsperrt'),
                        );
                    },
                    error: error => {
                        this.messageService.errorMessage(
                            'Fehler: Laborartikel konnte nicht gesperrt/entsperrt werden!',
                            error,
                        );
                    },
                });
            }
        });
    }

    openAddBehandlungsartikelDialog() {
        const dialogRef = this.dialog.open(AddBehandlungsartikelDialogComponent, {
            width: '1400px',
            maxWidth: '95vw',
            height: '90vh',
            maxHeight: '95vh',
            data: {},
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                // Tabelle neu laden
                this.api.reload('Artikel erstellt');
            }
        });
    }

    openEditBehandlungsartikelDialog(article: Material) {
        // Artikel-Daten laden
        const params = new HttpParams().set('artikel_id', article.artikel_id.toString());
        this.api.get(this.apiBaseUrl + 'behandlungsartikel/read_one.php', params).subscribe({
            next: response => {
                const dialogRef = this.dialog.open(AddBehandlungsartikelDialogComponent, {
                    width: '1400px',
                    maxWidth: '95vw',
                    height: '90vh',
                    maxHeight: '95vh',
                    data: { artikel: response },
                });

                dialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        // Tabelle neu laden
                        this.api.reload('Artikel aktualisiert');
                    }
                });
            },
            error: error => {
                this.messageService.errorMessage('Fehler beim Laden der Artikeldaten', error);
            },
        });
    }

    private deleteBehandlungsartikel(article: Material) {
        const enterValueInput = new EnterValueInput();
        enterValueInput.title = 'Artikel löschen';
        enterValueInput.text = 'Soll der Artikel "' + article.bezeichnung + '" wirklich gelöscht werden?';
        enterValueInput.okButton = 'Löschen';

        const dialogRef = this.dialog.open(EnterValueDialogComponent, { width: '700px', data: enterValueInput });

        dialogRef.afterClosed().subscribe(result => {
            if (result && result.result) {
                this.api.deleteEntity(this.apiBaseUrl + 'behandlungsartikel/delete.php', article).subscribe({
                    next: response => {
                        if (response.fehler) {
                            this.messageService.errorMessage(response.fehler, null);
                        } else if (response.fehler_recht) {
                            this.messageService.errorMessage(response.fehler_recht, null);
                        } else {
                            this.messageService.infoMessage('Artikel erfolgreich gelöscht');
                            this.api.reload('Artikel gelöscht');
                        }
                    },
                    error: error => {
                        this.messageService.errorMessage('Fehler: Artikel konnte nicht gelöscht werden!', error);
                    },
                });
            }
        });
    }
}
